var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 255,
    height: 205,
    viewBox: "0 0 255 205",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    transform: "translate(-1634 -1383)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1634 1383)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-2",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1659 1383)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-3",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1684 1383)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-4",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1709 1383)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-5",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1734 1383)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-6",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1759 1383)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-7",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1784 1383)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-8",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1809 1383)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-9",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1834 1383)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-10",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1859 1383)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-11",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1884 1383)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-12",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1634 1408)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-13",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1659 1408)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-14",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1684 1408)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-15",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1709 1408)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-16",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1734 1408)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-17",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1759 1408)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-18",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1784 1408)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-19",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1809 1408)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-20",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1834 1408)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-21",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1859 1408)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-22",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1884 1408)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-23",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1634 1433)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-24",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1659 1433)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-25",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1684 1433)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-26",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1709 1433)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-27",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1734 1433)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-28",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1759 1433)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-29",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1784 1433)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-30",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1809 1433)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-31",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1834 1433)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-32",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1859 1433)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-33",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1884 1433)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-34",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1634 1458)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-35",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1659 1458)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-36",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1684 1458)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-37",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1709 1458)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-38",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1734 1458)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-39",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1759 1458)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-40",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1784 1458)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-41",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1809 1458)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-42",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1834 1458)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-43",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1859 1458)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-44",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1884 1458)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-45",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1634 1483)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-46",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1659 1483)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-47",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1684 1483)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-48",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1709 1483)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-49",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1734 1483)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-50",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1759 1483)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-51",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1784 1483)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-52",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1809 1483)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-53",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1834 1483)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-54",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1859 1483)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-55",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1884 1483)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-56",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1634 1508)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-57",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1659 1508)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-58",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1684 1508)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-59",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1709 1508)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-60",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1734 1508)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-61",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1759 1508)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-62",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1784 1508)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-63",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1809 1508)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-64",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1834 1508)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-65",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1859 1508)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-66",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1884 1508)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-67",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1634 1533)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-68",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1659 1533)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-69",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1684 1533)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-70",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1709 1533)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-71",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1734 1533)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-72",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1759 1533)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-73",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1784 1533)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-74",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1809 1533)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-75",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1834 1533)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-76",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1859 1533)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-77",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1884 1533)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-78",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1634 1558)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-79",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1659 1558)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-80",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1684 1558)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-81",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1709 1558)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-82",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1734 1558)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-83",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1759 1558)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-84",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1784 1558)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-85",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1809 1558)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-86",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1834 1558)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-87",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1859 1558)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-88",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1884 1558)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-89",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1634 1583)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-90",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1659 1583)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-91",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1684 1583)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-92",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1709 1583)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-93",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1734 1583)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-94",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1759 1583)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-95",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1784 1583)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-96",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1809 1583)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-97",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1834 1583)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-98",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1859 1583)",
    fill: "#f85146"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-99",
    "data-name": "Ellipse 59",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1884 1583)",
    fill: "#f85146"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.6e6cd13e93a25147fe50c1da52a958f6.svg";
export { ForwardRef as ReactComponent };